import React, { Component, Fragment } from 'react';

import styles from './Footer.css'
import fonts from '../../styles/fonts.css'
import grid from '../../styles/grid.css'

class Footer extends Component {
    render() {
        var now = new Date();
        var currentYear = now.getFullYear();
        var siteVersion = 'v' + currentYear + '.' + (now.getMonth() + 1);

        return (
            <Fragment>
                <div className={grid.container}>
                    <div className={[fonts.title, styles.footer].join(' ')}>
                        <span className={styles.prompt}>$</span>
                        <span className={styles["footer-copy"]}>(c) 2014..{currentYear}</span>
                        <span className={styles.sep}>/</span>
                        <a href="mailto:e@trapeznikov.com">e@trapeznikov.com</a>
                        <span className={styles.sep}>/</span>
                        <a href="https://github.com/EugeneTrapeznikov" target="_blank" rel="noopener noreferrer">gthb</a>
                        <span className={styles.sep}>/</span>
                        <a href="https://www.linkedin.com/in/eugenetrapeznikov/" target="_blank" rel="noopener noreferrer">lnkdn</a>
                        <span className={styles["footer-version"]}>{siteVersion}</span>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Footer;
